import moment from 'moment';
import fetchMe from '../../../services/apollo/func/fetch/fetchMe';
import fetchUser from '../../../services/apollo/func/fetch/fetchUser';
import handleResetPassword from '../../../services/apollo/func/handle/handleResetPassword';
import handleDeleteUser from '../../../services/apollo/func/handle/handleDeleleUser';

export const formatStructureUserInfo = (rawData) => {
  const data = [
    {
      title: 'USER\'S INFORMATION',
      data: [
        {
          label: 'Username:',
          value: `${rawData?.firstName || '-'} ${rawData?.lastName || '-'}`,
          link: '',
        },
        {
          label: 'Email:',
          value: rawData?.email || '--',
          link: '',
        },
        {
          label: 'Created on:',
          value: rawData?.createdAt ? moment(rawData.createdAt).format('DD/MM/YYYY - HH:mm:ss') : '--',
          link: '',
        },
        {
          label: 'Created by:',
          value: rawData?.createdBy ? `${rawData?.createdBy?.firstName || '-'} ${rawData?.createdBy?.lastName || '-'}` : '--',
          link: '',
        },
      ],
    },
  ];
  return data;
};

export const getUserInfo = async (userId) => {
  try {
    const userInfo = await fetchUser({ userId });
    return formatStructureUserInfo(userInfo);
  } catch (error) {
    return {};
  }
};

export const getMeInfo = async () => {
  try {
    const userInfo = await fetchMe(1);
    return formatStructureUserInfo(userInfo);
  } catch (err) {
    return {};
  }
};

export const deleteUser = async (userId) => {
  try {
    const delUser = await handleDeleteUser({ userId });
    return delUser;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};

export const resetUserPassword = async (userId) => {
  try {
    const resetPassword = await handleResetPassword({ userId });
    return resetPassword;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};
